import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: translate({ id: 'gps.eventslist.view.actions.deleteEventTitle' }),
    confirmation: translate({
      id: 'gps.eventslist.view.actions.deleteEventConfirmation',
    }),
    description: translate({
      id: 'gps.eventslist.view.actions.deleteEventDescription',
    }),
  }))

  return api
}
